import React, { useMemo } from "react";
import Modal from "../Modal/Modal";
import CloseIcon from "../../assets/svg/close-icon";
import Button from "../Button/Button";

const convertBlackToWhite = (html: string): string => {
  return html
    .replace(/color:\s*#000000/gi, "color: #ffffff")
    .replace(/color:\s*#000(?![0-9a-f])/gi, "color: #fff")
    .replace(/color:\s*black/gi, "color: white")
    .replace(
      /color:\s*rgb\(\s*0\s*,\s*0\s*,\s*0\s*\)/gi,
      "color: rgb(255, 255, 255)"
    )
    .replace(
      /color:\s*rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*1\s*\)/gi,
      "color: rgba(255, 255, 255, 1)"
    );
};

const EmailSignatureDarkModePreview = ({
  open,
  onOpenChange,
  signatureHtml,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  signatureHtml: string;
}) => {
  const processedHtml = useMemo(
    () => convertBlackToWhite(signatureHtml),
    [signatureHtml]
  );

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/20 z-10000" />
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        showHeader={false}
        disableDefaultAnimation={true}
        contentClassName="!z-100000 w-[630px] h-[465px] overflow-hidden bg-fixed-white dark:bg-fixed-white-dk border border-border-gray-fixed dark:border-border-gray-fixed-dk animate-slide-down-modal"
        bodyClassName="w-full h-full !p-0"
        overlayClassName="!bg-transparent"
        preventOutsideClick={true}
        closeOnEscape={false}
      >
        <div className="p-[24px] w-full h-full flex flex-col gap-[24px]">
          <div className="flex justify-between w-full">
            <div className="flex flex-col w-full">
              <h3 className="text-verba-indigo-fixed dark:text-verba-indigo-fixed-dk text-base font-semibold">
                Dark Mode Preview
              </h3>
              <p className="text-xs font-normal text-dark-gray-fixed dark:text-dark-gray-fixed-dk">
                This is the dark mode preview of this signature. It shows how
                the original signature looks in dark theme.
              </p>
            </div>

            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className={`w-[15px] h-[15px] bg-gray-100 dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110`}
              aria-label="Close modal"
            >
              <CloseIcon className="w-[5.5px] h-[5.5px] text-verba-indigo dark:text-verba-indigo-dk" />
            </button>
          </div>

          <div className="w-full h-full  bg-verba-indigo-fixed dark:bg-verba-indigo-fixed-dk rounded-[8px] p-[16px] overflow-y-auto border border-border-gray-fixed dark:border-border-gray-fixed-dk">
            <div
              className="w-full h-full text-white text-md"
              dangerouslySetInnerHTML={{ __html: processedHtml }}
            />
          </div>

          <Button
            type="button"
            innerText="Close"
            onClick={() => onOpenChange(false)}
            buttonContainerClass="self-end rounded-[6px] flex items-center justify-center w-[100px] h-[36px] bg-fixed-white dark:bg-fixed-white-dk border border-verba-indigo-fixed dark:border-verba-indigo-fixed-dk"
            innerTextClass="shrink-0 text-md font-semibold text-verba-indigo-fixed dark:text-verba-indigo-fixed-dk"
          />
        </div>
      </Modal>
    </>
  );
};

export default EmailSignatureDarkModePreview;
